import * as React from 'react';
import styled from 'react-emotion';
import { styles } from './styles';

export const ToggleComponent = styled<'input'>('input')<React.InputHTMLAttributes<{}>>(({ checked, disabled }) => {
  return styles.toggle(checked, disabled);
});

interface Props {
  label?: JSX.Element;
}

export const Toggle: React.SFC<Props & React.InputHTMLAttributes<{}>> = props => (
  <div className={styles.toggleWrapper}>
    <ToggleComponent type={'checkbox'} {...props} disabled={props.disabled} checked={props.checked} />
    {props.label}
  </div>
);
